import { render, staticRenderFns } from "./campus_question_bank.vue?vue&type=template&id=14609930&scoped=true&"
import script from "./campus_question_bank.vue?vue&type=script&lang=js&"
export * from "./campus_question_bank.vue?vue&type=script&lang=js&"
import style0 from "./campus_question_bank.vue?vue&type=style&index=0&id=14609930&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14609930",
  null
  
)

export default component.exports